<template>
  <div class="bg-white border-b border-grey-lighter">
    <nav class="container mx-auto flex items-center justify-between flex-wrap p-6">
      <div class="flex items-center flex-no-shrink text-blue mr-6">
        <img class="h-16" :src="logo">
      </div>
      <div
        class="hidden md:block w-full mt-10 lg:mt-0 flex-grow lg:flex lg:items-center lg:w-auto justify-end"
      >
        <ul class="list-reset flex">
          <li>
            <a
              href="#home"
              v-smooth-scroll="{ duration: 1000}"
              class="text-grey-darkest no-underline p-4 mx-2 text-lg"
            >Home</a>
          </li>
          <li>
            <a
              href="#about-us"
              v-smooth-scroll="{ duration: 1000}"
              class="text-grey-darkest no-underline p-4 mx-2 text-lg"
            >About</a>
          </li>
          <li>
            <a
              href="#who-we-are"
              v-smooth-scroll="{ duration: 1000 }"
              class="text-grey-darkest no-underline p-4 mx-2 text-lg"
            >Who we are</a>
          </li>
          <li>
            <a
              href="#what-we-do"
              v-smooth-scroll="{ duration: 1000 }"
              class="text-grey-darkest no-underline p-4 mx-2 text-lg"
            >What we do</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>


<script>
import logo from "@/assets/logo.png";
import TheBreadcrumb from "@/components/TheBreadcrumb";
export default {
  name: "TheNavbar",

  components: {
    TheBreadcrumb
  },

  data() {
    return {
      logo: logo
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue